export default {"src":"/_next/static/media/final-project.6e817a40.gif","height":338,"width":600,"blurWidth":0,"blurHeight":0};